import Resource from '@/api/resources/Resource'

class LaboratoryConfigurationServices extends Resource {
    async getLaboratoryConfiguration(laboratoryId) {
        const response = await this.axios.get(`/configuration/laboratories/${laboratoryId}`)
        return response.data
    }
    async updateLaboratoryConfiguration(laboratoryId, request) {
        const response = await this.axios.patch(`/configuration/laboratories/${laboratoryId}`, request)
        return response.data
    }

    async getLaboratoryConfigurationLogo(laboratoryId) {
        const response = await this.axios.get(`/configuration/laboratories/${laboratoryId}/logo`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        })
        return response.data
    }
    async updateLaboratoryConfigurationLogo(laboratoryId, file) {
        const formData = new FormData()
        formData.append('file', file, file.name)
        const response = await this.axios.put(
            `/configuration/laboratories/${laboratoryId}/attachments/replaceLaboratoryLogo`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }

    async getLaboratoryConfigurationLogoReports(laboratoryId) {
        const response = await this.axios.get(`/configuration/laboratories/${laboratoryId}/getLogoForReports`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        })
        return response.data
    }

    async updateLaboratoryConfigurationLogoReports(laboratoryId, file) {
        const formData = new FormData()
        formData.append('file', file, file.name)
        const response = await this.axios.put(
            `/configuration/laboratories/${laboratoryId}/attachments/replaceLaboratoryLogoForReports`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }

    async deleteLaboratoryConfigurationLogo(laboratoryId, attachmentId) {
        const response = await this.axios.delete(`/configuration/laboratories/${laboratoryId}/attachments/${attachmentId}`)
        return response.data
    }

    async getLaboratoryConfigurationAttachments(laboratoryId) {
        const response = await this.axios.get(`/configuration/laboratories/${laboratoryId}/attachments`)
        return response.data
    }
}

export default new LaboratoryConfigurationServices()
